<template>
  <section class="py-5">
    <div class="container p-0">
      <div class="row gy-3">
        <div class="col-lg-6">
          <h5 class="text-uppercase">Let's be friends!</h5>
          <p class="text-sm text-muted mb-0">
            Nisi nisi tempor consequat laboris nisi.
          </p>
        </div>
        <div class="col-lg-6">
          <form action="#">
            <div class="input-group">
              <input
                class="form-control form-control-lg"
                type="email"
                placeholder="Enter your email address"
                aria-describedby="button-addon2"
              />
              <button class="btn btn-dark" id="button-addon2" type="submit">
                Subscribe
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "NewsLetter",
};
</script>

<style>
</style>